import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FarmerPoktanMember, KlbFarmer, KtgPenyuluhan } from './types'

const FARMER_POKTAN_MEMBER = (key?: string | Record<string, any>) =>
  ['farmer_poktan_member', key] as const

const searchFarmerPoktanMember = (params: {
  search?: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<ServiceGetAllResponse<FarmerPoktanMember[]>> => ({
  queryKey: FARMER_POKTAN_MEMBER(params),
  queryFn: async () => {
    try {
      const res = await api.get<ServiceGetAllResponse<FarmerPoktanMember[]>>(
        '/report/find-data/poktan-member',
        {
          params: {
            search: params.search,
            page: params.page,
            per_page: params.per_page
          }
        }
      )

      return {
        data: res.data?.data ?? [],
        message: res.data?.message ?? '',
        meta: res.data?.meta
      }
    } catch (error) {
      throw handleAxiosError(error)
    }
  },
  retry: false
})

const FARMER_KLB = (key?: string | Record<string, any>) =>
  ['farmer_klb', key] as const

const searchFarmerKLB = (params: {
  type?: string
  province_code?: string
  city_code?: string
  district_code?: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<ServiceGetAllResponse<KlbFarmer[]>> => ({
  queryKey: FARMER_KLB(params),
  queryFn: async () => {
    try {
      const res = await api.get<ServiceGetAllResponse<KlbFarmer[]>>(
        '/report/find-data/farmer-institutions',
        {
          params: {
            ...params,
            page: params.page ?? 1,
            per_page: params.per_page ?? 10
          }
        }
      )

      return {
        data: res.data?.data ?? [],
        message: res.data?.message ?? '',
        meta: res.data?.meta
      }
    } catch (error) {
      throw handleAxiosError(error)
    }
  },
  retry: false
})

const SEARCH_KTG = (key?: string | Record<string, any>) =>
  ['search_ktg', key] as const

const searchKtg = (params: {
  category_id: string
  search?: string
  page?: number
  per_page?: number
}): ServiceQueryOptionType<ServiceGetAllResponse<KtgPenyuluhan[]>> => ({
  queryKey: SEARCH_KTG(params),
  queryFn: async () => {
    try {
      const res = await api.get<ServiceGetAllResponse<KtgPenyuluhan[]>>(
        '/report/find-data/extension-personnel',
        {
          params: {
            category_id: params.category_id,
            search:
              (params.search ?? '').length > 2 ? params.search : undefined,
            page: params.page ?? 1,
            per_page: params.per_page ?? 10
          }
        }
      )

      return {
        data: res.data?.data ?? [],
        message: res.data?.message ?? '',
        meta: res.data?.meta
      }
    } catch (error) {
      throw handleAxiosError(error)
    }
  },
  retry: false
})

export const search = {
  queryKey: FARMER_POKTAN_MEMBER,
  poktanMember: searchFarmerPoktanMember,
  ktg: searchKtg,
  klb: searchFarmerKLB
}
